<div mat-dialog-content>
  <h4 mat-dialog-title>{{ 'ORDERS_PAGE.REFUNDS_POLICY_DIALOG.POLICY_TITLE' | translate }}</h4>
  <br />
  <h3>{{ 'ORDERS_PAGE.REFUNDS_POLICY_DIALOG.SECTION_1' | translate }}</h3>
  <h3>{{ 'ORDERS_PAGE.REFUNDS_POLICY_DIALOG.SECTION_2' | translate }}</h3>
  <h3>{{ 'ORDERS_PAGE.REFUNDS_POLICY_DIALOG.SECTION_3' | translate }}</h3>
</div>
